import React, { createContext, useCallback, useState } from 'react'
import LocalStorage, { Keys } from '../../Storage/LocalStorage'

const CHARGE_CODE_STORAGE_KEY = 'chargeCode'

const defaultChargeCode = {
  value: '',
  isActive: null,
  isChargeable: null,
  isClient: null,
  ed_email: '',
  isIAmEDChecked: false,
  isAgreementPolicyChecked: false,
  isWarRoomChecked: false
}

const defaultModal = {
  isOpen: false,
  pendingAction: null,
  actionLabel: '',
  datasetId: null
}

function loadChargeCodeFromStorage() {
  try {
    const stored = LocalStorage.get(Keys.CHARGE_CODE_INFORMATION)
    if (stored && stored[CHARGE_CODE_STORAGE_KEY]) {
      return { ...defaultChargeCode, ...stored[CHARGE_CODE_STORAGE_KEY] }
    }
  } catch (e) {
    // ignore
  }
  return defaultChargeCode
}

function saveChargeCodeToStorage(chargeCode) {
  try {
    const existing = LocalStorage.get(Keys.CHARGE_CODE_INFORMATION) || {}
    LocalStorage.set(Keys.CHARGE_CODE_INFORMATION, {
      ...existing,
      [CHARGE_CODE_STORAGE_KEY]: chargeCode
    })
  } catch (e) {
    // ignore
  }
}

export const ChargeCodeContext = createContext({
  chargeCode: { ...defaultChargeCode },
  setChargeCode: () => {},
  chargeCodeModal: defaultModal,
  openChargeCodeModal: () => {},
  closeChargeCodeModal: () => {}
})

export function ChargeCodeProvider({ children }) {
  const [chargeCode, setChargeCodeState] = useState(loadChargeCodeFromStorage)
  const [chargeCodeModal, setChargeCodeModal] = useState(defaultModal)

  const setChargeCode = useCallback((payload) => {
    setChargeCodeState((prev) => {
      const next = { ...prev, ...payload }
      saveChargeCodeToStorage(next)
      return next
    })
  }, [])

  const openChargeCodeModal = useCallback(
    ({ actionLabel = '', pendingAction = null, datasetId = null } = {}) => {
      setChargeCodeModal({
        isOpen: true,
        pendingAction,
        actionLabel,
        datasetId
      })
    },
    []
  )

  const closeChargeCodeModal = useCallback(() => {
    setChargeCodeModal(defaultModal)
  }, [])

  const value = {
    chargeCode,
    setChargeCode,
    chargeCodeModal,
    openChargeCodeModal,
    closeChargeCodeModal
  }

  return (
    <ChargeCodeContext.Provider value={value}>
      {children}
    </ChargeCodeContext.Provider>
  )
}
